export default {
  meta: {
    title: '销售周报',
    url: '/abside/week', // 埋点字段，上报归属的模块
    urlName: 'ab侧-销售周报', // 埋点字段，上报归属的模块
    logincallback: '/abside',
  }
};
